import React from "react";
import { Button, Typography, Stack, Box } from "@mui/material";
import ModalComponent from "./Modal";

const ConfirmationModal = ({
  open,
  handleClose,
  handleConfirm,
  title = "¿Está seguro?",
  description = "Esta acción no se puede deshacer.",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  confirmColor = "primary",
}) => {
  const buttonSx = {
    fontSize: {
      xs: "0.75rem",
      sm: "0.8125rem",
      md: "0.875rem",
    },
    px: {
      xs: 1.5,
      sm: 2,
    },
    py: {
      xs: 0.75,
      sm: 1,
    },
    minHeight: {
      xs: 36,
      sm: 40,
    },
    lineHeight: 1.2,
    textTransform: "none",
    whiteSpace: "normal",
    textAlign: "center",
  };

  return (
    <ModalComponent open={open} handleClose={handleClose} width="min(92vw, 460px)">
      <Box
        sx={{
          width: "100%",
          maxHeight: "calc(100vh - 64px)",
          overflowY: "auto",
          p: {
            xs: 0.5,
            sm: 1,
          },
        }}
      >
        <Typography
          component="h2"
          gutterBottom
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.1rem",
              md: "1.25rem",
            },
            lineHeight: 1.25,
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {title}
        </Typography>

        <Typography
          gutterBottom
          sx={{
            fontSize: {
              xs: "0.82rem",
              sm: "0.9rem",
              md: "1rem",
            },
            lineHeight: 1.45,
            color: "text.secondary",
            overflowWrap: "anywhere",
          }}
        >
          {description}
        </Typography>

        <Stack
          direction={{
            xs: "column-reverse",
            sm: "row",
          }}
          spacing={{
            xs: 1,
            sm: 2,
          }}
          justifyContent="flex-end"
          mt={{
            xs: 2,
            sm: 3,
          }}
          sx={{
            "& .MuiButton-root": {
              width: {
                xs: "100%",
                sm: "auto",
              },
            },
          }}
        >
          <Button
            sx={{
              ...buttonSx,
              color: "text.secondary",
              "&:hover": {
                color: "text.primary",
                bgcolor: "action.hover",
              },
            }}
            variant="outlined"
            onClick={handleClose}
          >
            {cancelText}
          </Button>

          <Button sx={buttonSx} variant="contained" color={confirmColor} onClick={handleConfirm}>
            {confirmText}
          </Button>
        </Stack>
      </Box>
    </ModalComponent>
  );
};

export default ConfirmationModal;
